// extracted by mini-css-extract-plugin
export default {"content":"LogoutModal_content__F-aZ7","buttonGroup":"LogoutModal_buttonGroup__C2loS","text":"LogoutModal_text__4HnBe"};